import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getAzureBillApi = async (param, provider) => {
  try {
    param.params.type = 2;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/billing" : "previous-monthly-billing";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};
